'use strict'

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '';

export const supabase = createClient(url, key, {
  auth: {
    // Required for magic link to work — detects the access_token hash in the URL
    // on redirect back from the email link and automatically exchanges it for a session
    detectSessionInUrl: true,
    // Persist session in localStorage so page refreshes keep the user logged in
    persistSession: true,
    autoRefreshToken: true,
  },
});
